import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  ZAvatar, BackButton, OutlinedIcons, Logo as ZicassoLogo,
} from '@marageti/z4-lib';
import { TripRequest } from '@marageti/z4-sdk/lib/travel';
import SubNavigation from '../sub-navigation';

type TripRequestSecondaryAppbarViewProps = {
  tripRequest?: TripRequest | undefined;
};

const TripRequestSecondaryAppbarView = ({
  tripRequest,
}: TripRequestSecondaryAppbarViewProps) => {
  const navigate = useNavigate();
  const handleBack = useCallback(() => {
    const targetPath = tripRequest?.id ? `/trip-requests/${tripRequest.id}` : '/';
    navigate(targetPath, { replace: true });
  }, [navigate, tripRequest?.id]);

  return (
    <SubNavigation
      profile={{
        avatar: (
          <ZAvatar
            src={ZicassoLogo}
            alt="Zicasso Traveler Care"
            size={32}
            sx={{ backgroundColor: 'common.gold', color: 'background.default' }}
          />
        ),
        primary: 'Zicasso Traveler Care',
      }}
      startAdornment={(
        <BackButton
          data-e2e="ztest-trip-match-back"
          onClick={handleBack}
          edge="start"
        >
          <OutlinedIcons.OutlinedArrowSmLeftIcon color="primary" />
        </BackButton>
      )}
    />
  );
};

export default TripRequestSecondaryAppbarView;
